package dev.lingvo.site.pages.app.projects.slug

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import dev.lingvo.site.ds.LoadingState
import dev.lingvo.site.ds.Space

/**
 * The old import/export page, now a redirect to `/data`.
 *
 * **It was 571 lines of second implementation.** `/data` shipped the import that shows you the plan
 * before it applies anything, and this page kept its own import that did not — so the product had
 * two ways to bring strings in, one of which could silently obsolete keys, and a link on `/data`
 * offering to send you to the better one. Two live pages doing one job is how a bug gets fixed in
 * the one nobody uses.
 *
 * **Export was what kept it alive, and moving that is what let this go.** `/data` did not implement
 * export at all; it linked back here for it. Redirecting before `ExportCard` existed would have
 * pointed that link at itself and taken export off the product entirely — which is a thing worth
 * writing down, because the plan of record said to redirect this page and delete it, and following
 * that plan literally would have shipped a loop.
 *
 * A redirect rather than a deletion because the URL is in browser histories and in at least one
 * shipped `/app` card. `replaceState` rather than a push, so Back returns to wherever the reader
 * came from instead of bouncing them through here again.
 */
@Page("/app/projects/{slug}/import-export")
@Layout(".components.layouts.AppLayout")
@Composable
fun ImportExportPage() {
    val ctx = rememberPageContext()
    val slug = ctx.route.params["slug"].orEmpty()

    LaunchedEffect(slug) {
        ctx.router.navigateTo(
            "/app/projects/$slug/data",
            updateHistoryMode = com.varabyte.kobweb.navigation.UpdateHistoryMode.REPLACE,
        )
    }

    // Briefly visible at most. A skeleton rather than the word "Redirecting", because the reader is
    // on their way to a page that opens with exactly this shape.
    Column(Modifier.fillMaxWidth().gap(Space.XXL)) { LoadingState(rows = 3) }
}
